import { ManagementApi } from '@/features/api/services/managementApi'
import {
  CLUB_SELF_REGISTRATION_DISABLED,
  CLUB_SELECTOR_PATH,
} from '@/features/auth/clubSelfRegistrationConfig.js'
import { getClubSelectorPushQuery } from '@/features/auth/useAuthRedirection.js'
import { useAuthStore } from '@/features/auth/useAuthStore.js'
import { getActiveClubId } from '@/features/router/useActiveClub.js'
import { useIsSuperAdmin } from '@/features/superAdmin/useIsSuperAdmin'

function redirectUnfinalizedClubRegistration(next, redirectUrl, clubId) {
  if (CLUB_SELF_REGISTRATION_DISABLED) {
    next({
      path: CLUB_SELECTOR_PATH,
      query: getClubSelectorPushQuery(redirectUrl),
    })
    return
  }

  next(`/club-register?clubId=${clubId}`)
}

export async function clubRegisteredGuard(to, from, next) {
  const authStore = useAuthStore()
  const isSuperAdmin = useIsSuperAdmin()

  const routeClubId = Array.isArray(to?.query?.activeClubId)
    ? to.query.activeClubId[0]
    : to?.query?.activeClubId
  const clubId = routeClubId || getActiveClubId()

  const redirectUrl = to.fullPath

  console.log('[clubRegisteredGuard] Checking club registration for clubId:', clubId, to, from)

  if (!clubId && !isSuperAdmin) {
    console.log('[clubRegisteredGuard] No clubId found in route')
    next({
      path: '/auth/club-selector',
      query: getClubSelectorPushQuery(to.fullPath),
    })
    return
  }

  const clubs = authStore?.myDetails?.myTenants || []

  if (clubs.length === 0) {
    console.log('[clubRegisteredGuard] No clubs found on myTenants')
  }

  const club = clubs.find(club => club.tenantId === clubId)

  if (!club) {
    if (isSuperAdmin) {
      console.log('[clubRegisteredGuard] Super admin, no club found')
      console.log('[clubRegisteredGuard] we need to check that this club is waiting for finalize')

      const tenant = await ManagementApi.tenantGetDetails(clubId)

      console.log('[clubRegisteredGuard] tenant', tenant)

      if (!tenant) {
        console.log('[clubRegisteredGuard] tenant not found')
        next()
        return
      }

      if (!tenant?.isRegisteredFinalized) {
        console.log('[clubRegisteredGuard] Club is waiting for registration')
        redirectUnfinalizedClubRegistration(next, redirectUrl, clubId)
        return
      }

      next()
      return
    }

    console.log('[clubRegisteredGuard] Club not found')
    next({
      path: '/auth/club-selector',
      query: getClubSelectorPushQuery(to.fullPath),
    })
    return
  }

  if (!club.isRegisteredFinalized) {
    console.log('[clubRegisteredGuard] Club not registered completely')
    redirectUnfinalizedClubRegistration(next, redirectUrl, clubId)
    return
  }

  console.log('[clubRegisteredGuard] Club registered')

  next()
}
